var _rect, _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0008 22.7871V22.5681C12.033 21.9202 12.2406 21.2925 12.6024 20.7496C13.2045 20.0975 13.6167 19.2983 13.7957 18.436C13.7957 17.7695 13.7957 17.0935 13.8539 16.427C14.1547 13.2184 17.3273 11 20.4611 11H20.5387C23.6725 11 26.845 13.2184 27.1555 16.427C27.2137 17.0935 27.1555 17.7695 27.204 18.436C27.3854 19.3003 27.7972 20.1019 28.3974 20.7591C28.7618 21.2972 28.9698 21.9227 28.9989 22.5681V22.7776C29.0206 23.648 28.7208 24.4968 28.1548 25.1674C27.407 25.9515 26.3921 26.4393 25.3024 26.5384C22.107 26.8812 18.883 26.8812 15.6876 26.5384C14.5991 26.435 13.5858 25.9479 12.8352 25.1674C12.278 24.4963 11.9822 23.6526 12.0008 22.7871Z",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0547 29.8518C18.554 30.4785 19.2871 30.884 20.092 30.9788C20.8968 31.0735 21.7069 30.8495 22.343 30.3564C22.5387 30.2106 22.7147 30.041 22.8669 29.8518",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 3,
    r: 3,
    fill: "#66B32E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNotification);
export default __webpack_public_path__ + "static/media/newNotification.045092f6.svg";
export { ForwardRef as ReactComponent };